import { MenuOptions } from './MenuOptions';
import ic_kidiLogo from '/icons/ic_kidi_logo.svg?raw'

export function CreateLogoOptions(container: TSelection<"div">) {
    container.append("div").classed("main-options", true)
        .on("click", () => new MenuOptions())
        .html(ic_kidiLogo)
        .select("svg")
        .attr("class", "img-logo-options");
}